module.exports = __webpack_public_path__ + "media/images/icons/chat-c0252dd188b7aa0b562aa1f38fd0ac05.svg";